(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    connectedCallback() {

      this.headerSection =
        document.querySelector('.section-header');

      this.updateHeaderHeight =
        this.updateHeaderHeight.bind(this);

      this.updateHeaderHeight();

      if (window.ResizeObserver && this.headerSection) {

        this.resizeObserver =
          new ResizeObserver(() => {
            this.updateHeaderHeight();
          });

        this.resizeObserver.observe(this.headerSection);
      }

      window.addEventListener(
        'resize',
        this.updateHeaderHeight,
        { passive: true }
      );
    }

    updateHeaderHeight() {

      if (!this.headerSection) {
        return;
      }

      const height =
        this.headerSection.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${height}px`
      );
    }

    disconnectedCallback() {

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      window.removeEventListener(
        'resize',
        this.updateHeaderHeight
      );
    }
  }

  if (!customElements.get('sticky-header')) {

    customElements.define(
      'sticky-header',
      StickyHeader
    );

  }



  class RsAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.rs-announcement-slide'));
      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

      if (this.slides.length < 2) return;

      const interval = Number(this.dataset.interval) || 4000;
      this.rotationTimer = window.setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const isActive = index === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
      }, interval);
    }

    disconnectedCallback() {
      if (this.rotationTimer) window.clearInterval(this.rotationTimer);
    }
  }

  if (!customElements.get('rs-announcement-bar')) {
    customElements.define('rs-announcement-bar', RsAnnouncementBar);
  }

  /*
   * Mobile menu accordion.
   * Una voce principale con figli è un titolo espandibile:
   * il suo click non deve portare alla collection padre.
   */
  function initRsMobileMenuAccordion(drawer) {
    if (!drawer || drawer.dataset.rsAccordionReady === 'true') return;
    drawer.dataset.rsAccordionReady = 'true';

    drawer.addEventListener('click', (event) => {
      if (!window.matchMedia('(max-width: 989px)').matches) return;

      const summary = event.target.closest('.menu-drawer__menu > li > details > summary');
      if (summary && drawer.contains(summary)) {
        const details = summary.parentElement;
        if (details && details.querySelector(':scope > .menu-drawer__submenu')) {
          event.preventDefault();
          event.stopPropagation();

          /*
           * Catalogo/Prodotti: primo tap = mostra le categorie;
           * secondo tap = apre Tutti i prodotti.
           */
          if (details.open && /catalogo|prodotti/i.test(summary.textContent.trim())) {
            window.location.href = '{{ routes.all_products_collection_url }}';
            return;
          }

          details.open = !details.open;
          details.classList.toggle('menu-opening', details.open);
          summary.setAttribute('aria-expanded', String(details.open));
        }
        return;
      }

      const parentLink = event.target.closest('.menu-drawer__menu > li > a.menu-drawer__menu-item');
      if (parentLink && drawer.contains(parentLink) && parentLink.parentElement.querySelector(':scope > details > .menu-drawer__submenu')) {
        event.preventDefault();
        event.stopPropagation();
        const details = parentLink.parentElement.querySelector(':scope > details');
        if (details) {
          details.open = !details.open;
          details.classList.toggle('menu-opening', details.open);
        }
      }
    }, true);
  }

  document.querySelectorAll('header-drawer').forEach(initRsMobileMenuAccordion);
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('header-drawer').forEach(initRsMobileMenuAccordion);
  });


  } catch(e) { console.error(e); }
})();
})();
